<template>
  <vs-row vs-type="flex" vs-justify="flex-start" style="width:100%;">
    <vs-col
      class="aisea-text-14-400-black"
      vs-type="flex"
      vs-justify="flex-start"
      vs-align="center"
      style="width: 220px; margin: 0.4rem 0;"
      >
      <span class="aisea-text-14-400-black" style="white-space: nowrap;">
        コンテナ数：{{ counts.container_count }}
      </span>
    </vs-col>

    <vs-col style="padding:0;margin:0;background-color:none;width:384px;" >
      <vs-row>

        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          style="width: 204px; margin: 0.4rem 0;"
        >
          <div class="color-chip active" />
          <span class="aisea-text-14-400-black" style="margin-right:0.8rem; white-space: nowrap;">
            正常：{{ counts.active_count }}
          </span>
          <div class="color-chip interlock" />
          <span class="aisea-text-14-400-black" style="margin-right:0.8rem; white-space: nowrap;">
            監視休止：{{ counts.interlock_count }}
          </span>

        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          style="min-width: 180px; width: calc(100% - 204px); margin: 0.4rem 0;"
        >

          <div class="color-chip alert" />
          <span class="aisea-text-14-400-black" style="margin-right:0.8rem; white-space: nowrap;">
            異常：{{ counts.alert_count }}
          </span>
          <div class="color-chip power-off" />
          <span class="aisea-text-14-400-black" style="margin-right:0.8rem; white-space: nowrap;">
            非稼働：{{ counts.power_off_count }}
          </span>
        </vs-col>

      </vs-row>
    </vs-col>
  </vs-row>
</template>

<script>
export default {
  props: {
    counts: {
      container_count: { type: Number },
      active_count: { type: Number },
      alert_count: { type: Number },
      interlock_count: { type: Number },
      power_off_count: { type: Number },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
.status-text {
  font-weight: 400;
  margin-left: 25px;
  max-width: 200px;
}
.color-chip {
  min-width: 15px;
  max-width: 15px;
  height: 15px;
  border-radius: 15px;
  margin-right: 0.2rem;
}
.active {
  background-color: $aisea-green;
  border: solid 2px lighten($aisea-green, 20%);
}
.alert {
  background-color: $aisea-pink;
  border: solid 2px lighten($aisea-pink, 10%);
}
.interlock {
  background-color: $aisea-mouse-gray;
  border: 2px solid rgba($aisea-mouse-gray, 0.5);
  background-clip: padding-box;
}
.power-off {
  background-color: $aisea-light-gray;
  border: 2px solid $aisea-mouse-gray;
}
</style>